import "materialize-css";

const MaterializeCollapsibleDirective = function () {
    return function (scope, element, attrs) {
        element.collapsible({
            accordion: attrs.collapsible == "accordion"
        });
    };
};

export { MaterializeCollapsibleDirective };